import areEnhancedLocationsEqual from './utils/areEnhancedLocationsEqual';
import createEnhancedLocations from './utils/createEnhancedLocations';
import createEnhancedLocationsFromPersonaControlViewState from './utils/createEnhancedLocationsFromPersonaControlViewState';
export { getLocationPostalAddress } from './utils/getLocationPostalAddress';
export { getLocationDisplayText } from './utils/getLocationDisplayText';
export { getLocationDisplayWithAddressText } from './utils/getLocationDisplayWithAddressText';
export { getLocalizedAddress, getLocalizedAddressFromDetails } from './utils/getLocalizedAddress';
export {
    createLocationPersonaFromStringLocation,
} from './utils/createLocationPersonaFromStringLocation';
export { createLocationPersonaFromPersonaType } from './utils/createLocationPersonaFromPersonaType';
export { createLocationPersonaFromRoomInfo } from './utils/createLocationPersonaFromRoomInfo';
export {
    createLocationPersonaFromEnhancedLocation,
} from './utils/createLocationPersonaFromEnhancedLocation';
export {
    LocationPersonaControlViewState,
    LocationSelectionSource,
} from './data/schema/LocationPersonaControlViewState';
export { LocationPersonaControl } from './components/LocationPersonaControl';
export { LocationCardWrapper } from './components/LocationCardWrapper';
export { LocationCard } from './components/LocationCard';
export { default as getBingUrl } from './utils/getBingUrl';
export { default as calculateMapUrl } from './utils/calculateMapUrl';
export { default as isEnhancedLocation } from './utils/isEnhancedLocation';
export { default as isRoom } from './utils/isRoom';
export { default as getLocationTextStyle } from './utils/getLocationTextStyle';
import { LazyImport, LazyModule } from 'owa-bundling';
export { LocationRelevanceData } from './data/schema/LocationRelevanceData';
export { createEnhancedLocationFromRoomInfo } from './utils/createEnhancedLocationFromRoomInfo';
export {
    containsLocation,
    containsLocationWithId,
    containsRoomWithEmail,
} from './utils/areEnhancedLocationsEqual';
export { getRoomEmailFromLocation } from './utils/getRoomEmailFromLocation';
export {
    createEnhancedLocationFromStringLocation,
} from './utils/createEnhancedLocationFromStringLocation';
export {
    areEnhancedLocationsEqual,
    createEnhancedLocations,
    createEnhancedLocationsFromPersonaControlViewState,
};
export {
    default as createEnhancedLocationFromTxpData,
} from './utils/createEnhancedLocationFromTxpData';

const lazyModule = new LazyModule(() => import('./lazyIndex'));

export let lazyCreateTxpPostalAddressFromLocationPersona = new LazyImport(
    lazyModule,
    m => m.createTxpPostalAddressFromLocationPersona
);
